"use client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"

import { Button } from "@/components/ui/button"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import i18n from "@/lang/i18n"

const FormSchema = z.object({
  loginToken: z.coerce.number({
    required_error: "Login Token is required",
    invalid_type_error: "Login Token must be a number",
  }).min(1, "Login Token is required"),
})

interface LoginTokenFormProps {
    handleConfirm: (loginToken: number) => void;
}

const LoginTokenForm: React.FC<LoginTokenFormProps> = ({ handleConfirm }) => {
  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema)
  })

  function onSubmit(data: z.infer<typeof FormSchema>) {
    handleConfirm(data.loginToken);
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="w-full">
        <FormField
          control={form.control}
          name="loginToken"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="mb-5 block w-full px-[6px] text-center text-white font-semibold text-[20px] text-center">{i18n.t('enter_login_token')}</FormLabel>
              <FormControl>
                <Input className="bg-transparent text-white placeholder-white" placeholder={i18n.t('enter_login_token')} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button className="mt-3" variant="secondary" type="submit">{i18n.t('confirm')}</Button>
      </form>
    </Form>
  )
}

export default LoginTokenForm